<template>
  <div>
    <div
      v-show="showMenu"
      class="menu"
      :style="{
        left: `${x}px`,
        top: `${y}px`
      }"
    >
      <span
        class="item"
        @mousedown.prevent="handleAction('annotate')"
      >
        Annotate
      </span>
      <!-- You can add more buttons here -->
    </div>

    <!-- The insterted text should be displayed here -->
    <slot/>
  </div>
</template>

<script>

export default {
  data() {
    return {
      x: 0,
      y: 0,
      showMenu: false,
      selectedText: '',
      selection: undefined,
      selectionRange: undefined,
    }
  },
  mounted () {
    window.addEventListener('mouseup', this.onMouseup)
  },
  beforeDestroy () {
    window.removeEventListener('mouseup', this.onMouseup)
  },
  methods: {
    onMouseup () {
      const selection = window.getSelection()
      const selectionRange = selection.getRangeAt(0).cloneRange();
      this.selection = selection;

      // crazy work around to see if selection is inside the div of the rendered pdf page
      if (selection.anchorNode.parentElement.parentElement.parentElement.className !== 'page') {
        this.showMenu = false;
        return;
      }

      // startNode is the element that the selection starts in
      const startNode = selectionRange.startContainer.parentNode
      // endNode is the element that the selection ends in
      const endNode = selectionRange.endContainer.parentNode

      // Get the x, y, and width of the selection
      const { x, y, width } = selectionRange.getBoundingClientRect()

      // If width === 0 (i.e. no selection)
      // Then, hide the menu
      if (width === 0 || !width) {
        this.showMenu = false
        return
      }

      // Finally, if the selection is valid,
      // set the position of the menu element,
      // set selectedText to content of the selection
      // then, show the menu
      this.x = x + (width / 3)
      this.y = y + window.scrollY - 140;
      this.selectedText = selection.toString()
      this.showMenu = true
      this.selectionRange = selectionRange;
    },
    handleAction (action) {
      // add an if here to check if they click the annotate we then highlight the text
      this.$emit(action, this.selectedText, this.selectionRange)
    }
  }
}
</script>

<style>
.menu {
  height: 30px;
  padding: 5px 10px;
  background: #333;
  border-radius: 3px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -100%);
  transition: 0.2s all;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.menu:after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -5px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #333;
}

.item {
  color: #FFF;
  cursor: pointer;
}

.item:hover {
  color: #1199ff;
}

.item + .item {
  margin-left: 10px;
}

.annotatedText {
  background-color: blue;
}

</style>